import { render, staticRenderFns } from "./WorkIconDocumentAdd.vue?vue&type=template&id=7b6cfa9c"
import script from "./WorkIconDocumentAdd.vue?vue&type=script&lang=js"
export * from "./WorkIconDocumentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports